import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ModalComponent } from './modal.component'
import { VideoInfoModal } from './shared/video-info-modal.component'
import { VideoPurchaseModal } from './shared/video-purchase-modal.component'
import { NewVideoCustomerModal } from './shared/new-video-customer-modal.component'
import { NewVideoSubscriptionLearnMoreModal } from './shared/new-video-subscription-learn-more-modal.component'
import { NewMultipassSubscriptionVideo } from './shared/new-multipass-subscription-video.component'
import { ExportPostsModalComponent } from './shared/export-posts-modal/export-posts-modal.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MaterialModule } from '../material/material.module'
import { EmbedVideo } from './shared/embed-video.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  declarations: [
    ModalComponent,
    VideoInfoModal,
    VideoPurchaseModal,
    NewVideoCustomerModal,
    NewVideoSubscriptionLearnMoreModal,
    NewMultipassSubscriptionVideo,
    ExportPostsModalComponent,
    EmbedVideo
  ],
  exports: [
    ModalComponent,
    VideoInfoModal,
    VideoPurchaseModal,
    NewVideoCustomerModal,
    NewVideoSubscriptionLearnMoreModal,
    NewMultipassSubscriptionVideo,
    ExportPostsModalComponent,
  ]
})
export class ModalModule {}
